 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_cover'
 import HTML02_COPYRIGH from '@/components/html/02_Copyrigh'
 import HTML01_TITLE from '@/components/html/01_Title'
 import HTML03_DEDICATI from '@/components/html/03_Dedicati'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_ACKNOWLE from '@/components/html/05_Acknowle'
 import HTML06_INTRODUC from '@/components/html/06_Introduc'
 import HTML07_PART_ONE from '@/components/html/07_PART_ONE'
 import HTML08_1_SIN from '@/components/html/08_1_Sin'
 import HTML09_2_HEALTH from '@/components/html/09_2_Health'
 import HTML10_PART_TWO from '@/components/html/10_PART_TWO'
 import HTML11_3_CHANGE from '@/components/html/11_3_Change'
 import HTML12_4_CHANGE from '@/components/html/12_4_Change'
 import HTML13_PART_THR from '@/components/html/13_PART_THR'
 import HTML14_5_SUCCES from '@/components/html/14_5_Succes'
 import HTML15_6_BREAKI from '@/components/html/15_6_Breaki'
 import HTML16_CONCLUSI from '@/components/html/16_Conclusi'
 import HTML17_NOTES from '@/components/html/17_Notes'
 import HTML18_BIBLIOGR from '@/components/html/18_Bibliogr'
 import HTML19_INDEX from '@/components/html/19_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Acknowle",
 			"name" : "html/05_Acknowle",
 			"component" : HTML05_ACKNOWLE
 		},
 		{
 			"path" : "/html/06_Introduc",
 			"name" : "html/06_Introduc",
 			"component" : HTML06_INTRODUC
 		},
 		{
 			"path" : "/html/07_PART_ONE",
 			"name" : "html/07_PART_ONE",
 			"component" : HTML07_PART_ONE
 		},
 		{
 			"path" : "/html/08_1_Sin",
 			"name" : "html/08_1_Sin",
 			"component" : HTML08_1_SIN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js